<template>
  <div class="wrapper" :class="{ 'error-input': isError }" @click="$refs.input.focus()">
    <span class="prefix">{{ prefix }}</span>
    <span class="suffix">{{ suffix }}</span>

    <!-- captureMode시 입력 글자 쏠림현상때문에 padding-top으로 위치 맞춤 및 가이드문구 안보이게 처리 -->
    <div class="input-box" :style="`${captureMode ? 'padding-top: 14px' : ''}`">
      <span :class="{ 'opacity-0': captureMode }">{{ guideText }}</span>
      <input
        v-model="inputValue"
        autofocus
        type="text"
        ref="input"
        :class="{ 'primary--text': isCorrectInput }"
        @input="checkInput($event.target.value)"
        inputmode="decimal"
      />
    </div>
  </div>
</template>

<script>
import { commaFormat } from '@/filter/number'
import { mapState } from 'vuex'

export default {
  props: ['prefix', 'suffix', 'placeholder', 'isAgree'],
  data() {
    return {
      inputValue: '',
    }
  },
  computed: {
    ...mapState('ui', ['captureMode', 'showErrorMode']),
    isError() {
      return this.showErrorMode && !this.isAgree
    },
    guideText() {
      let result = this.placeholder

      if (this.isAmountInput) {
        result = commaFormat(result)
      }

      return result.toString()
    },
    isAmountInput() {
      // 타입이 금액(정수 천단위 컴마 표기)인지 이율(소수점 입력)인지 구분
      return this.placeholder.toString().indexOf('.') < 0
    },
    isCorrectInput() {
      return this.inputValue === this.guideText
    },
  },
  methods: {
    checkInput(value) {
      if (!value) return

      let newValue = value.toString()
      // 숫자만 남김(소수점입력인 경우 점까지 허용)
      const regex = this.isAmountInput ? /^0+|\D+/g : /[^\d.]+/g
      newValue = value.replace(regex, '')

      if (newValue.length < 1) return (this.inputValue = 0)

      // 가이드 문구  원본 길이만큼 제한
      newValue = newValue.substring(0, this.placeholder.toString().length)

      // 금액인경우 천단위 콤마 삽입
      if (this.isAmountInput) {
        newValue = commaFormat(newValue)
      }

      this.inputValue = newValue
      this.$emit('update:isAgree', this.isCorrectInput)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common/_variables.scss';
$height: 48px;

.wrapper {
  border: solid 1px #d7e1ea;
  border-radius: 4px;
  height: $height;
  padding: 0 15px;
  cursor: text;

  .prefix {
    float: left;
    line-height: $height;
  }

  .suffix {
    float: right;
    line-height: $height;
  }

  .input-box {
    position: relative;
    float: right;
    line-height: $height;
    margin-right: 5px;

    span {
      color: #8a94a2;
      font-weight: 900;
    }

    input {
      position: absolute;
      left: 0;
      font-weight: 900;
      outline: none;
      width: 120%;
    }
  }
}

.error-input {
  &.wrapper {
    border: 1px solid $red !important;
  }
  span,
  input {
    color: $red !important;
  }
}

.wrapper,
span,
input {
  -webkit-transition: all 0.5s ease-out;
  -moz-transition: all 0.5s ease-out;
  -o-transition: all 0.5s ease-out;
  transition: all 0.5s ease-out;
}
</style>
